import React from 'react';
import { GraduationCap, Code2, Brain, Users, Target } from 'lucide-react';

const EndorsementSection = () => {
  return (
    <section className="endorsement-section">
      <div className="endorsement-content">
        <div className="endorsement-icons">
          <GraduationCap size={36} />
          <Code2 size={36} />
          <Brain size={36} />
          <Users size={36} />
          <Target size={36} />
        </div>
        <h2 className="section-title">El Poder de la Investigación Aplicada a tus Resultados</h2>
        <p className="section-subtitle" style={{ maxWidth: '800px' }}>
          Gestas ML es el resultado tangible de una profunda alianza entre nuestro equipo de desarrollo y el esfuerzo constante del equipo de investigación de la Universidad de Murcia. Hemos unido años de riguroso estudio científico con un cuidadoso y perseverante trabajo tecnológico con un único objetivo: crear una herramienta potente, fiable y con validación académica, diseñada para ayudarte a mejorar cada día.
        </p>
      </div>
    </section>
  );
};

export default EndorsementSection;